import axios from "axios";

let notificationHandler: ((message: string) => void) | null = null;

export const setNotificationHandler = (
  handler: (message: string) => void
) => {
  notificationHandler = handler;
};

//const url = import.meta.env.VITE_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use((config) => {
  const stored = localStorage.getItem("user");
  if (stored) {
    const user = JSON.parse(stored);
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401)
      localStorage.removeItem("user");

      const message =
      error.response?.data?.message ||
      error.message ||
      "Unexpected error occurred";

    if (notificationHandler) {
      notificationHandler(message);
      console.error(message);
    }

    return Promise.reject(error);
  }
);

export default api;